/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, Card, Divider } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import emailLogo from '../../../assets/images/email.png';
import { sendEmailConfirmation } from "../../../services/authService";
import { Toaster } from "../../../shared/components/common/toaster";
import { TextWrapper } from "../../../shared/components/formUtilities/useTextWrapper";
import { RegistrationNavBar } from "../components/registrationNavBar";

export const VerifyEmail = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const [timer, setTimer] = useState(0);
  const [loading, setLoading] = useState(false);
  const query = new URLSearchParams(location.search);
  const email = query.get('e');
  const isLogin = query.get('type') == 1;

  useEffect(() => {
    if (isLogin && email) {
      onSendEmail();
    }
  }, [isLogin]);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => (prev > 1 ? prev - 1 : 0));
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const onSendEmail = () => {
    setLoading(true);
    sendEmailConfirmation(decodeURIComponent(email)).then(resp => {
      setLoading(false);
      setTimer(30);
      Toaster({ msg: t('emailSentSuccessfully'), isError: false });
    }).catch(err => { setLoading(false); });
  };
  return <Box className='w-full h-full'>
    <RegistrationNavBar marginBottom={0} isShowPlatform={false} isShowProfile={false}></RegistrationNavBar>
    <Box className='flex items-center justify-center md:p-0 p-4 w-full md:h-[85%] md:mt-0 mt-[32px]'>
      <Box component={Card} className="md:w-[520px] w-full flex flex-col justify-center !rounded-lg items-center p-8">
        <Box className='bg-[#f2fcf7] p-4 flex items-center justify-center h-[100px] w-[100px] rounded-full shadow-sm'>
          <Box className='h-[90px] w-[90px]'>
            <img className={`!h-full object-contain`} src={emailLogo} alt="Email Logo"></img>
          </Box>
        </Box>
        <Box className='mt-3'>
          <TextWrapper classList="!font-semibold md:!text-[22px] text-[18px]" text={t('emailConfirmation')} />
        </Box>
        <Box className='text-sm caption !text-center mt-2 mb-8'>
          <span>{t('weHaveSentEmailTo')}</span>
          &nbsp;<a className="text-sm !font-[500]">{email}</a>&nbsp;
          <span>{t('toConfirmValidity')}</span>
        </Box>
        {email ? <>
          <Divider className="w-full" />
          <Box className={`text-sm caption mt-4 !text-center ${loading ? 'pointer-events-none' : ''}`}>
            {timer > 0 ? <span>{t('resendEamilAfter')} <strong>{timer}</strong> {t('seconds')}</span> : <>
              <span>{t('ifYouNotGotAnyEmail')}</span>
              &nbsp;<a className="text-sm cursor-pointer hover:underline" onClick={() => {
                onSendEmail();
              }}>{t("resendConfirmationEmail")}</a>
            </>}
          </Box>
        </> : null}
      </Box>
    </Box>
  </Box>;
};